import { z } from "zod";
import { blogPostFrontmatterSchema, richContentBlockSchema } from "./schema.ts";

const metadata = blogPostFrontmatterSchema.extend({
  readingTime: z.string().min(1),
});
export const articleSummarySchema = z.discriminatedUnion("status", [
  metadata.extend({ status: z.literal("idea") }),
  metadata.extend({ status: z.literal("draft") }),
  metadata.extend({ status: z.literal("ready") }),
  metadata.extend({ status: z.literal("published"), image: z.string().min(1) }),
]);
export type BlogPostSummary = z.infer<typeof articleSummarySchema>;
export type PublishedBlogPostSummary = Extract<
  BlogPostSummary,
  { status: "published" }
>;
export const publicArticleSummarySchema = metadata.extend({
  status: z.literal("published"),
  image: z.string().min(1),
});
// Project the body first because summary schemas deliberately reject unknown keys.
export function parseArticleDetail(value: unknown) {
  const body = z
    .object({ content: z.array(richContentBlockSchema) })
    .parse(value);
  const record = z.record(z.string(), z.unknown()).parse(value);
  const { content: _content, ...summary } = record;
  void _content;
  return { ...articleSummarySchema.parse(summary), ...body };
}
export type ArticleDetail = ReturnType<typeof parseArticleDetail>;
export const publicArticleDetailSchema = publicArticleSummarySchema.extend({
  content: z.array(richContentBlockSchema),
});
export const publicArticleListSchema = z.array(publicArticleSummarySchema);
export interface ArticleSource {
  get(slug: string, signal?: AbortSignal): Promise<ArticleDetail | null>;
}
